export function renderFamilyMemberName(member, allFamilyMembers) {
    if (!member?.user) {
        return;
    }

    if (
        member.user.firstName &&
        !allFamilyMembers.find(
            someoneElse =>
                someoneElse.user.firstName === member.user.firstName && someoneElse.pawn.pawnId !== member.pawn.pawnId
        )
    ) {
        return member.user.firstName;
    }

    if (
        member.user.firstName &&
        member.user.lastName &&
        !allFamilyMembers.find(
            someoneElse =>
                someoneElse.user.lastName === member.user.lastName && someoneElse.pawn.pawnId !== member.pawn.pawnId
        )
    ) {
        return `${member.user.firstName} ${member.user.lastName}`;
    }

    if (member.user.firstName) {
        return `${member.user.firstName} (${member.user.username})`;
    }

    return member.user.username;
}
